import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SpecialismList } from '@boels/models';
import { StoreFinderFacade } from '@boels/shared-state';

@Injectable()
export class StoreFinderSpecialismDropdownService {
  private router = inject(Router);
  private storeFinderFacade = inject(StoreFinderFacade);

  specialisms$: Observable<SpecialismList> =
    this.storeFinderFacade.getStoreFinderSpecialisms();

  navigateToSpecialism(specialismCode: string | null): void {
    const noSpecialismParams =
      specialismCode === null || specialismCode === '0';
    const url = this.router.createUrlTree([], {
      queryParamsHandling: 'merge',
      queryParams: {
        specialism: noSpecialismParams ? null : specialismCode,
      },
    });
    this.router.navigateByUrl(url);
  }
}
